import { render, staticRenderFns } from "./WhatsappInfo.vue?vue&type=template&id=7db6fb72&"
import script from "./WhatsappInfo.vue?vue&type=script&lang=js&"
export * from "./WhatsappInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports